module.exports = __webpack_public_path__ + "img/ar_ar.ba1660d4.png";